import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'core'

import { DatasetCharts, TrainingCharts, ExplanationCharts } from 'pages/Charts'

const ChartsRouter = props => {
  const { match } = props

  return (
    <Switch>
      <Redirect
        path={`${match.path}`}
        to={({ match: route }) => {
          return `${route.url}/datasets`
        }}
      />
      <Route path={`${match.path}/datasets`} component={DatasetCharts} />
      <Route path={`${match.path}/trainings`} component={TrainingCharts} />
      <Route path={`${match.path}/explanations`} component={ExplanationCharts} />
      <Route
        render={({ location: loc }) => {
          return (
            <pre>{`  404 Page Not Found\n\n  The page under "${loc.pathname}" does not exist.`}</pre>
          )
        }}
      />
    </Switch>
  )
}

ChartsRouter.propTypes = {
  match: PropTypes.exact({
    path: PropTypes.string,
    url: PropTypes.string,
    params: PropTypes.object,
    isExact: PropTypes.bool,
  }),
}

export default ChartsRouter
